import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
export function Countdown() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    label: 'Hours'
  }, {
    value: minutes,
    label: 'Min'
  }, {
    value: seconds,
    label: 'Sec'
  }];
  return <div className="flex items-start justify-center gap-1.5 sm:gap-3" data-id="element-61" data-mp="3q1du2cuu5q90">
      {units.map((unit, i) => <React.Fragment key={unit.label} data-id="element-62" data-mp="3c1ctyzmeamul" data-mpi={i}>
          {i > 0 && <span className="pt-2.5 font-display text-xl text-gold/50 sm:pt-3 sm:text-3xl" aria-hidden="true" data-id="element-63" data-mp="3c48qqkmib5hg">
              :
            </span>}
          <div className="w-[3.75rem] rounded-xl border border-line bg-panel px-2 py-2.5 text-center sm:w-20 sm:py-3" data-id="element-64" data-mp="3262qe7gcm7ep">
            <span className="block font-display text-xl tabular-nums text-cream sm:text-3xl" data-id="element-65" data-mp="10cl8mayi7q68">
              {unit.value}
            </span>
            <span className="mt-1 block text-[9px] font-semibold uppercase tracking-[0.14em] text-cream-muted sm:text-[10px]" data-id="element-66" data-mp="15a4zcace1vf2">
              {unit.label}
            </span>
          </div>
        </React.Fragment>)}
    </div>;
}